import { CleaningReportRoutes } from "./routes"

export const CleaningReportPage = () => {
    return <CleaningReportRoutes />
}
